import React from 'react'
import { ReactSession } from 'react-client-session';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { Markup } from 'interweave';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon,
    PinterestIcon,
    EmailIcon
} from "react-share";

import classes from './Global.module.css';
import styles from '../../App.module.css';
import noThumb from "../../images/no-thumb.jpg";

function SingleGroup(group) {
    const { uid } = useParams();
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");

    if(logged_user) {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/grouplike.php`, {
            user_id: logged_user,
            group_id: group.id,
            action: 'isgrouplike'
        },
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            if(res.data.islike) {
                group.islike = true;
            }else {
                group.islike = false;
            }
        }
        ).catch(err => {
            console.log(err);
        })
    }

    const addGroup = () => {
        if(logged_user) {
            const toast_id = toast.loading("Please wait...");
            axios.post(`${process.env.REACT_APP_API_URL}/api/user/groupadd.php`, {
                user_id: logged_user,
                group_id: group.id,
                action: 'groupadd'
            },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                console.log(res.data);
                toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
            }).catch(err => {
                console.log(err);
            })
        }
    }

    const handleLike = () => {
        if(logged_user) {
            const toast_id = toast.loading("Please wait...");
            axios.post(`${process.env.REACT_APP_API_URL}/api/user/grouplike.php`, {
                user_id: logged_user,
                group_id: group.id,
                action: 'grouplike'
            },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                if(res.data.message === "Like added") {
                    document.querySelectorAll(`.group-${group.id} .counter`)[0].innerHTML = group.rate += 1;
                    document.querySelectorAll(`.group-${group.id} .${classes.like_btn}`)[0].classList.add(classes.liked);
                }else if(res.data.message === "Like removed!") {
                    if(group.rate > 0) {
                        document.querySelectorAll(`.group-${group.id} .counter`)[0].innerHTML = group.rate -= 1;
                        document.querySelectorAll(`.group-${group.id} .${classes.like_btn}`)[0].classList.remove(classes.liked);
                    }
                }
                
                toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
            }).catch(err => {
                console.log(err);
            })
        }
    }

    const delGroup = (id) => {
        const group = document.getElementById(`group_${id}`);
        if(group) {
            if(window.confirm("Are you sure you want to delete this group?")) {
                const toast_id = toast.loading("Please wait...");
                axios.post(`${process.env.REACT_APP_API_URL}/api/user/group.php`, {  
                        uid: logged_user,
                        id: id,
                        action: 'delGroup'
                    }, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    }).then(res => {
                        console.log(res.data);
                        
                        if(res.data.status === 'success') {
                            // group.remove();
                            toast.update(toast_id, {render: "Group deleted successfully.", autoClose: 5000, type: "success", isLoading: false});
                        }else {
                            toast.update(toast_id, {render: "Something went wrong!", autoClose: 5000, type: "error", isLoading: false});
                        }
                    }).catch(err => {
                        console.log(err);
                    })
            }
        }
    }

    const config = "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30";

    return (
        <div id={`group_${group.id}`} className={`group-${group.id} card ` + styles.card}>
            <Link to={`/group/${group.id}/${group.nice_url}`}>
                <img className={`card-img-top ` + styles.card_image} src={group.thumb} onError={e => {e.target.src = noThumb}} alt={group.groupName} />
            </Link>
            <div className={`card-block text-center ${styles.card_block}`}>
                <div className={styles.cart_content}>
                    <h4 className={styles.card_title}><Markup content={group.groupName}></Markup></h4>
                    <p className={styles.card_text}><Markup content={group.description}></Markup></p>
                </div>
                <div className={classes.card_bottom}>
                    <div className={styles.social_share_buttons}>
                        <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://twitter.com/intent/tweet?url=https://wesharez.com/group/${group.id}/${group.nice_url}&text=${group.groupName}`, "Popup", config)}>
                            <TwitterIcon size={32} round={true} />
                        </Link>
                        <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://www.linkedin.com/shareArticle?mini=true&url=https://wesharez.com/group/${group.id}/${group.nice_url}&title=${group.groupName}`, "Popup", config)}>
                            <LinkedinIcon size={32} round={true} />
                        </Link>
                        <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://pinterest.com/pin/create/link/?url=https://wesharez.com/group/${group.id}/${group.nice_url}&title=${group.groupName}&media=${group.thumb}&description=${group.groupName}`, "Popup", config)}>
                            <PinterestIcon size={32} round={true} />
                        </Link>
                        <a className={`${styles.social__icon}`} href={`whatsapp://send?text=https://wesharez.com/group/${group.id}/${group.nice_url}`} data-action="share/whatsapp/share">
                            <WhatsappIcon size={32} round={true} />
                        </a>
                        <a className={`${styles.social__icon}`} href={`mailto:?subject=${group.groupName}&body=https://wesharez.com/group/${group.id}/${group.nice_url}`}>
                            <EmailIcon size={32} round={true} />
                        </a>
                    </div>
                    <div className={classes.btn_group}>
                        {
                            (uid === undefined || (uid !== logged_user)) && <button className={`${classes.add_btn} btn`} onClick={addGroup}><i className="fa-solid fa-square-plus"></i> ADD Group</button>
                        }
                        {
                            (uid !== undefined && (uid === logged_user)) && <button className={`${classes.del_btn} btn`} onClick={() => delGroup(group.id)}><i className="fa-solid fa-trash-can"></i> Delete</button>
                        }
                    </div>
                    <div className={`${classes.meta} row`}>
                        <div className="col-6">
                            <span className={classes.views}>{group.view_count} views</span>
                        </div>
                        <div className="col-6">
                            <button className={`${classes.like_btn} btn ${group.islike && classes.liked}`} onClick={handleLike}>
                                <i className="fa-solid fa-thumbs-up"></i>
                                <span><span className="counter">{group.rate}</span> likes</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SingleGroup